import React from 'react';
import PropTypes from 'prop-types';

/**
 * Empty State Component
 * Displays an empty state message with optional icon, title, message, and action
 * @param {Object} props - Component props
 * @param {React.ReactNode} [props.icon] - Icon element to display
 * @param {string} props.title - Empty state title
 * @param {string} [props.message] - Empty state message/description
 * @param {React.ReactNode} [props.action] - Action button or element
 */
export const EmptyState = ({ icon, title, message, action }) => (
  <div className="empty-state">
    {icon && <div className="empty-state-icon">{icon}</div>}
    <h3 className="empty-state-title">{title}</h3>
    {message && <p className="empty-state-message">{message}</p>}
    {action && <div className="empty-state-action">{action}</div>}
  </div>
);

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  action: PropTypes.node
};

